import axios from "axios";
import Layout from "../../Common/Layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BrainTestQuestion from "./BrainTestQuestion";
import { TestSideBar } from "../TestSideBar/TestSideBar";
import {
  canTakeTest,
  getCurrentUserInfo,
  newTestTaken,
} from "../../../services/userService";
import { getDefaultProfilePic } from "../testService";
import { toast } from "react-toastify";

async function fetchQuestions() {
  const response = await fetch(
    "https://branchselector--get-questions.anish98821.workers.dev/?query=brain"
  );
  var data = await response.json();
  data = data.questions;
  console.log(data);
  return data;
}

const BrainTestPage = () => {
  const [fetchedQuestions, setFetchedQuestions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 5;

  const [userDetails, setUserDetails] = useState(null);

  var isLastPage;
  const [radioValues, setRadioValues] = useState([]);

  //Function is called every time the radio button is clicked
  const handleRadioChange = (index, value) => {
    setRadioValues((prevValues) => {
      const newRadioValues = [...prevValues];
      newRadioValues[index] = value;
      return newRadioValues;
    });
  };
  useEffect(() => {
    const checkAllowed = async () => {
      try {
        const validity = await canTakeTest();
        if (validity) {
        } else {
          navigate("/dashboard");
          toast.error("No more free tests left on the account");
        }
      } catch (error) {
        console.error("Not premium", error);
        setLoading(false);
      }
    };

    checkAllowed();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const questions = await fetchQuestions();
        setFetchedQuestions(questions);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching questions:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (fetchedQuestions) {
      const initRadioValues = Array.from(
        { length: fetchedQuestions.length },
        () => "0"
      );
      setRadioValues(initRadioValues);
      console.log(initRadioValues);
    }
  }, [fetchedQuestions]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDetails = await getCurrentUserInfo();
        console.log(userDetails);
        setUserDetails(userDetails);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    fetchUserData();
  }, userDetails);

  const handlePrevPage = () => {
    window.scroll(0, 0);
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    if (!isAllAnswered()) {
      alert("Please answer all the questions! ");
      return;
    }
    window.scroll(0, 0);
    setCurrentPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(fetchedQuestions.length / questionsPerPage)
      )
    );
  };

  const navigate = useNavigate();
  const renderQuestions = () => {
    const startIndex = (currentPage - 1) * questionsPerPage;
    const endIndex = startIndex + questionsPerPage;
    isLastPage =
      currentPage === Math.ceil(fetchedQuestions.length / questionsPerPage);
    var questions = fetchedQuestions
      .slice(startIndex, endIndex)
      .map((item, index) => (
        <BrainTestQuestion
          key={startIndex + index}
          item={item}
          radioValue={radioValues[startIndex + index]}
          onRadioChange={(value) =>
            handleRadioChange(startIndex + index, value)
          }
        />
      ));
    return questions;
  };

  const isAllAnswered = () => {
    const startIndex = (currentPage - 1) * questionsPerPage;
    const endIndex = startIndex + questionsPerPage;
    for (var i = startIndex; i < endIndex; i++) {
      if (radioValues[i] == "0") return false;
    }
    return true;
  };

  // Once the test is complete the test details along with the user details stored in local storage from the
  // pre-test menu are sent to a cloudflare worker where a mail containing the result is sent to the user.
  const sendApi = () => {
    if (!isAllAnswered()) {
      alert("Please answer all the questions! ");
      return;
    }
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    const brainResults = {
      Left: 0,
      Right: 0,
    };

    //Results are calculated in this function
    radioValues.forEach((element) => {
      if (element === "left") {
        brainResults.Left += 1;
      } else if (element === "right") {
        brainResults.Right += 1;
      }
    });

    const resultList = [
      ["Left", brainResults.Left],
      ["Right", brainResults.Right],
    ];

    user["brain"] = resultList;
    axios
      .post(
        "https://branchselctor--get-results.anish98821.workers.dev/?query=brain",
        user,
        {
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        navigate("/brain/results", { state: { brainResults } });
        newTestTaken("Brain Test", "temp_brain test");
        console.log("testtaken test for brain");
      })
      .catch((error) => {
        console.log(error);
        alert("Somthing went wrong plz try again later");
      });
  };
  return (
    <Layout>
      {userDetails != null && !loading ? (
        <div className="test-main-container">
          <TestSideBar
            profilePic={
              userDetails["photoUrl"]
                ? userDetails["photoUrl"]
                : getDefaultProfilePic()
            }
            userName={
              userDetails["displayName"] ? userDetails["displayName"] : "User"
            }
            email={
              userDetails["email"] ? userDetails["email"] : "user@mail.com"
            }
            testName={"Brain Test"}
            answeredQuestions={5}
            totalQuestions={15}
          />

          <div className="test-container">
            {currentPage == 1 && (
              <div>
                <h1 id="instruct">Instructions!</h1>
                <br />
                <div id="instructionTxt">
                  <div id="instructionContents">
                    <ul>
                      <li>
                        &nbsp;While answering the test, be honest. Answer to
                        express, not to impress.
                      </li>
                      <li>
                        &nbsp;Do not ask for suggestions with friends/check
                        online for answers while answering the questions.
                      </li>
                      <li>
                        &nbsp;Take the test 2 times to get better understanding
                        of your preferences.
                      </li>
                      <li>
                        &nbsp;Read the e-Book from the Downloads section to
                        understand the various branches and the career
                        opportunities.
                      </li>
                    </ul>
                  </div>
                </div>{" "}
              </div>
            )}
            <br />
            {fetchedQuestions && (
              <h3 id="questionHeading">
                Please answer the following questions ({currentPage}/
                {Math.ceil(fetchedQuestions.length / questionsPerPage)})
              </h3>
            )}
            <br />
            {loading ? (
              <p id="loadTxt">Loading...</p>
            ) : (
              <div>
                <div>{renderQuestions()}</div>
                <br />
                <div className="takeQuizBtns">
                  <div className="backNextBtns">
                    <button
                      id="backBtn"
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      Back
                    </button>
                    {!isLastPage && (
                      <button
                        id="nextBtn"
                        onClick={handleNextPage}
                        disabled={
                          currentPage ===
                          Math.ceil(fetchedQuestions.length / questionsPerPage)
                        }
                      >
                        Next
                      </button>
                    )}
                  </div>
                  <div className="getResultBtn">
                    {isLastPage && (
                      <button
                        id="resultBtn"
                        onClick={() => {
                          sendApi();
                        }}
                      >
                        Get Result
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="loading-screen">Loading...</div>
      )}
    </Layout>
  );
};

export default BrainTestPage;
